import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Translation files
import en from './locales/en.json';
import hi from './locales/hi.json'; // Hindi example

i18n
  .use(LanguageDetector) // Detects browser language
  .use(initReactI18next) // Passes i18n to react-i18next
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
    },
    fallbackLng: "en", // default language
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

export default i18n;
